export default __webpack_public_path__ + "static/media/autoportret.594fb51c.jpg";